import { Helmet } from 'react-helmet-async';
import { Zap, ArrowRight, Maximize2 } from 'lucide-react';

export default function SalesDeckPage() {
  return (
    <div className="min-h-screen bg-[#0B1220] text-white flex flex-col">
      <Helmet>
        <title>BookingFlows — Sales Deck</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <header className="flex items-center justify-between px-6 sm:px-10 py-5">
        <a href="/" className="flex items-center gap-2" data-testid="deck-logo-link">
          <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center">
            <Zap className="w-4.5 h-4.5 text-white" />
          </div>
          <span className="font-bold text-lg tracking-tight">BookingFlows</span>
        </a>
        <a
          href="https://gamma.app/embed/1su23fugzfj4p3w"
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-1.5 text-xs text-blue-300 hover:text-white transition-colors"
          data-testid="deck-fullscreen-link"
        >
          <Maximize2 className="w-3.5 h-3.5" /> Open full screen
        </a>
      </header>

      <main className="flex-1 flex flex-col items-center px-4 sm:px-8 pb-10">
        <div className="w-full max-w-5xl">
          <div className="relative w-full rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-blue-950/50 bg-black/40" style={{ paddingBottom: '62.5%' }}>
            <iframe
              src="https://gamma.app/embed/1su23fugzfj4p3w"
              className="absolute inset-0 w-full h-full"
              allow="fullscreen"
              title="BookingFlows"
              data-testid="deck-iframe"
            />
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-slate-400" data-testid="deck-tagline">
              The booking platform built for boat, jet ski &amp; watersport operators.
            </p>
            <a
              href="/#pricing"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-blue-600 hover:bg-blue-500 text-sm font-semibold transition-colors"
              data-testid="deck-cta-btn"
            >
              See plans &amp; get started <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </main>

      <footer className="px-6 py-4 text-center text-[11px] text-slate-500">
        © {new Date().getFullYear()} BookingFlows · <a href="/privacy" className="hover:text-slate-300">Privacy</a>
      </footer>
    </div>
  );
}
